export enum TimeStep {
  HALF_AN_HOUR = 10,
  HOUR = 15,
  DAY = 20,
  WEEK = 30,
  MONTH = 40,
  YEAR = 50,
}
